import { useStaticQuery, graphql } from "gatsby";
import { useMemo } from "react";
import { Document } from "flexsearch";
import { flexTokenize, flexId, flexFields } from "../../shared-flexsearch-config";

function expandQuery(query) {
  const terms = new Set();
  const lower = query.toLowerCase().trim();
  terms.add(lower);
  if (lower.endsWith("ies")) {
    terms.add(lower.slice(0, -3) + "y");
  }
  if (lower.endsWith("s")) {
    terms.add(lower.slice(0, -1));
  } else {
    terms.add(lower + "s");
    terms.add(lower + "es");
  }
  return Array.from(terms);
}

export default function useFlexSearchResults(query) {
  const { localSearchProducts } = useStaticQuery(graphql`
    query {
      localSearchProducts {
        index
        store
      }
    }
  `);

  const results = useMemo(() => {
    if (!query || query.length < 3) return [];

    const index = localSearchProducts.index;
    const store = localSearchProducts.store;
    const storeById = Object.fromEntries(
      Object.values(store).map((doc) => [doc.id, doc])
    );

    const flex = new Document({
      tokenize: flexTokenize,
      document: {
        id: flexId,
        index: flexFields,
      },
    });

    flex.import(index);
    Object.values(store).forEach((doc) => flex.add(doc));

    const expandedQueries = expandQuery(query);
    const resultMap = new Map();

    expandedQueries.forEach((term) => {
      const matches = flex.search(term);
      matches.forEach((match) => {
        match.result.forEach((id) => {
          const doc = storeById[id];
          if (doc) {
            resultMap.set(doc.id, doc);
          }
        });
      });
    });

    return Array.from(resultMap.values());
  }, [query, localSearchProducts]);

  return results;
}
